export default __webpack_public_path__ + "static/media/bg_ip_01.fc09d5fffc546a044a2c80a126135a18.svg";